module.exports = __webpack_public_path__ + "static/media/exchange.43cb06bb.svg";